import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";

interface PurchaseAndBillIndicatorProps {
  label?: string;
}

const PurchaseAndBillIndicator: React.FC<PurchaseAndBillIndicatorProps> = ({
  label = "Purchase & Bill",
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const accent = colors.info[300];

  return (
    <Box
      component="span"
      aria-label="Purchase and Bill indicator"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        flexShrink: 0,
        pointerEvents: "none",
        userSelect: "none",
        px: 1.35,
        py: 0.4,
        borderRadius: "999px",
        border: `1px solid ${accent}66`,
        backgroundColor: `${accent}18`,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: "0.78rem",
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: accent,
          lineHeight: 1.3,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default PurchaseAndBillIndicator;
